export const en = {
    titreOnglet: "AccèsD Affaires | Desjardins"
};
